export const WORKFLOW_SET_SELECTED_MEMBERS = 'WORKFLOW_SET_SELECTED_MEMBERS';
export const WORKFLOW_TOGGLE_MEMBER = 'WORKFLOW_TOGGLE_MEMBER';
export const WORKFLOW_TOGGLE_MEMBERS = 'WORKFLOW_TOGGLE_MEMBERS';
export const WORKFLOW_CLEAR_SELECTION = 'WORKFLOW_CLEAR_SELECTION';
export const WORKFLOW_SET_TEMPLATE = 'WORKFLOW_SET_TEMPLATE';
export const WORKFLOW_SET_NAME = 'WORKFLOW_SET_NAME';
export const WORKFLOW_SET_GOAL = 'WORKFLOW_SET_GOAL';
export const WORKFLOW_START = 'WORKFLOW_START';
export const WORKFLOW_SET_SELECTED_NODE = 'WORKFLOW_SET_SELECTED_NODE';
export const WORKFLOW_UPDATE_NODE_FIELD = 'WORKFLOW_UPDATE_NODE_FIELD';
export const WORKFLOW_SET_NEW_NODE_FIELD = 'WORKFLOW_SET_NEW_NODE_FIELD';
export const WORKFLOW_ADD_NODE = 'WORKFLOW_ADD_NODE';
export const WORKFLOW_ADD_BRANCH = 'WORKFLOW_ADD_BRANCH';
export const WORKFLOW_INSERT_AFTER = 'WORKFLOW_INSERT_AFTER';
export const WORKFLOW_UPDATE_EDGE_LABEL = 'WORKFLOW_UPDATE_EDGE_LABEL';
export const WORKFLOW_CONNECT_NODES = 'WORKFLOW_CONNECT_NODES';
export const WORKFLOW_DELETE_NODE = 'WORKFLOW_DELETE_NODE';

export const WORKFLOW_TEMPLATES_REQUEST = 'WORKFLOW_TEMPLATES_REQUEST';
export const WORKFLOW_TEMPLATES_SUCCESS = 'WORKFLOW_TEMPLATES_SUCCESS';
export const WORKFLOW_TEMPLATES_FAILURE = 'WORKFLOW_TEMPLATES_FAILURE';
export const WORKFLOW_TEMPLATE_REQUEST = 'WORKFLOW_TEMPLATE_REQUEST';
export const WORKFLOW_TEMPLATE_SUCCESS = 'WORKFLOW_TEMPLATE_SUCCESS';
export const WORKFLOW_TEMPLATE_FAILURE = 'WORKFLOW_TEMPLATE_FAILURE';
export const WORKFLOW_TEMPLATE_CREATE_REQUEST =
  'WORKFLOW_TEMPLATE_CREATE_REQUEST';
export const WORKFLOW_TEMPLATE_CREATE_SUCCESS =
  'WORKFLOW_TEMPLATE_CREATE_SUCCESS';
export const WORKFLOW_TEMPLATE_CREATE_FAILURE =
  'WORKFLOW_TEMPLATE_CREATE_FAILURE';

export const WORKFLOW_LIST_REQUEST = 'WORKFLOW_LIST_REQUEST';
export const WORKFLOW_LIST_SUCCESS = 'WORKFLOW_LIST_SUCCESS';
export const WORKFLOW_LIST_FAILURE = 'WORKFLOW_LIST_FAILURE';
export const WORKFLOW_DETAIL_REQUEST = 'WORKFLOW_DETAIL_REQUEST';
export const WORKFLOW_DETAIL_SUCCESS = 'WORKFLOW_DETAIL_SUCCESS';
export const WORKFLOW_DETAIL_FAILURE = 'WORKFLOW_DETAIL_FAILURE';
export const WORKFLOW_CREATE_REQUEST = 'WORKFLOW_CREATE_REQUEST';
export const WORKFLOW_CREATE_SUCCESS = 'WORKFLOW_CREATE_SUCCESS';
export const WORKFLOW_CREATE_FAILURE = 'WORKFLOW_CREATE_FAILURE';
export const WORKFLOW_UPDATE_REQUEST = 'WORKFLOW_UPDATE_REQUEST';
export const WORKFLOW_UPDATE_SUCCESS = 'WORKFLOW_UPDATE_SUCCESS';
export const WORKFLOW_UPDATE_FAILURE = 'WORKFLOW_UPDATE_FAILURE';
export const WORKFLOW_PUBLISH_REQUEST = 'WORKFLOW_PUBLISH_REQUEST';
export const WORKFLOW_PUBLISH_SUCCESS = 'WORKFLOW_PUBLISH_SUCCESS';
export const WORKFLOW_PUBLISH_FAILURE = 'WORKFLOW_PUBLISH_FAILURE';
export const WORKFLOW_ARCHIVE_REQUEST = 'WORKFLOW_ARCHIVE_REQUEST';
export const WORKFLOW_ARCHIVE_SUCCESS = 'WORKFLOW_ARCHIVE_SUCCESS';
export const WORKFLOW_ARCHIVE_FAILURE = 'WORKFLOW_ARCHIVE_FAILURE';
export const WORKFLOW_CLONE_REQUEST = 'WORKFLOW_CLONE_REQUEST';
export const WORKFLOW_CLONE_SUCCESS = 'WORKFLOW_CLONE_SUCCESS';
export const WORKFLOW_CLONE_FAILURE = 'WORKFLOW_CLONE_FAILURE';

export const WORKFLOW_VALIDATE_REQUEST = 'WORKFLOW_VALIDATE_REQUEST';
export const WORKFLOW_VALIDATE_SUCCESS = 'WORKFLOW_VALIDATE_SUCCESS';
export const WORKFLOW_VALIDATE_FAILURE = 'WORKFLOW_VALIDATE_FAILURE';

export const WORKFLOW_BINDINGS_REQUEST = 'WORKFLOW_BINDINGS_REQUEST';
export const WORKFLOW_BINDINGS_SUCCESS = 'WORKFLOW_BINDINGS_SUCCESS';
export const WORKFLOW_BINDINGS_FAILURE = 'WORKFLOW_BINDINGS_FAILURE';
export const WORKFLOW_BINDING_CREATE_REQUEST =
  'WORKFLOW_BINDING_CREATE_REQUEST';
export const WORKFLOW_BINDING_CREATE_SUCCESS =
  'WORKFLOW_BINDING_CREATE_SUCCESS';
export const WORKFLOW_BINDING_CREATE_FAILURE =
  'WORKFLOW_BINDING_CREATE_FAILURE';
export const WORKFLOW_BINDING_DELETE_REQUEST =
  'WORKFLOW_BINDING_DELETE_REQUEST';
export const WORKFLOW_BINDING_DELETE_SUCCESS =
  'WORKFLOW_BINDING_DELETE_SUCCESS';
export const WORKFLOW_BINDING_DELETE_FAILURE =
  'WORKFLOW_BINDING_DELETE_FAILURE';

export const WORKFLOW_TRIGGERS_REQUEST = 'WORKFLOW_TRIGGERS_REQUEST';
export const WORKFLOW_TRIGGERS_SUCCESS = 'WORKFLOW_TRIGGERS_SUCCESS';
export const WORKFLOW_TRIGGERS_FAILURE = 'WORKFLOW_TRIGGERS_FAILURE';

export const WORKFLOW_ENROLL_REQUEST = 'WORKFLOW_ENROLL_REQUEST';
export const WORKFLOW_ENROLL_SUCCESS = 'WORKFLOW_ENROLL_SUCCESS';
export const WORKFLOW_ENROLL_FAILURE = 'WORKFLOW_ENROLL_FAILURE';
export const WORKFLOW_ENROLLMENTS_REQUEST = 'WORKFLOW_ENROLLMENTS_REQUEST';
export const WORKFLOW_ENROLLMENTS_SUCCESS = 'WORKFLOW_ENROLLMENTS_SUCCESS';
export const WORKFLOW_ENROLLMENTS_FAILURE = 'WORKFLOW_ENROLLMENTS_FAILURE';
export const WORKFLOW_UNENROLL_REQUEST = 'WORKFLOW_UNENROLL_REQUEST';
export const WORKFLOW_UNENROLL_SUCCESS = 'WORKFLOW_UNENROLL_SUCCESS';
export const WORKFLOW_UNENROLL_FAILURE = 'WORKFLOW_UNENROLL_FAILURE';

export const WORKFLOW_RUNS_REQUEST = 'WORKFLOW_RUNS_REQUEST';
export const WORKFLOW_RUNS_SUCCESS = 'WORKFLOW_RUNS_SUCCESS';
export const WORKFLOW_RUNS_FAILURE = 'WORKFLOW_RUNS_FAILURE';
export const WORKFLOW_RUN_REQUEST = 'WORKFLOW_RUN_REQUEST';
export const WORKFLOW_RUN_SUCCESS = 'WORKFLOW_RUN_SUCCESS';
export const WORKFLOW_RUN_FAILURE = 'WORKFLOW_RUN_FAILURE';
export const WORKFLOW_RUN_CREATE_REQUEST = 'WORKFLOW_RUN_CREATE_REQUEST';
export const WORKFLOW_RUN_CREATE_SUCCESS = 'WORKFLOW_RUN_CREATE_SUCCESS';
export const WORKFLOW_RUN_CREATE_FAILURE = 'WORKFLOW_RUN_CREATE_FAILURE';
export const WORKFLOW_RUN_ACTION_REQUEST = 'WORKFLOW_RUN_ACTION_REQUEST';
export const WORKFLOW_RUN_ACTION_SUCCESS = 'WORKFLOW_RUN_ACTION_SUCCESS';
export const WORKFLOW_RUN_ACTION_FAILURE = 'WORKFLOW_RUN_ACTION_FAILURE';
export const WORKFLOW_RUN_EVENTS_REQUEST = 'WORKFLOW_RUN_EVENTS_REQUEST';
export const WORKFLOW_RUN_EVENTS_SUCCESS = 'WORKFLOW_RUN_EVENTS_SUCCESS';
export const WORKFLOW_RUN_EVENTS_FAILURE = 'WORKFLOW_RUN_EVENTS_FAILURE';

export const WORKFLOW_STEP_COMPLETE_REQUEST = 'WORKFLOW_STEP_COMPLETE_REQUEST';
export const WORKFLOW_STEP_COMPLETE_SUCCESS = 'WORKFLOW_STEP_COMPLETE_SUCCESS';
export const WORKFLOW_STEP_COMPLETE_FAILURE = 'WORKFLOW_STEP_COMPLETE_FAILURE';
export const WORKFLOW_STEP_INPUT_REQUEST = 'WORKFLOW_STEP_INPUT_REQUEST';
export const WORKFLOW_STEP_INPUT_SUCCESS = 'WORKFLOW_STEP_INPUT_SUCCESS';
export const WORKFLOW_STEP_INPUT_FAILURE = 'WORKFLOW_STEP_INPUT_FAILURE';

export const WORKFLOW_CLEAR_ERROR = 'WORKFLOW_CLEAR_ERROR';
